<ng-container
  *ngIf="
    authService.currentUserSig() === null ||
      authService.currentUserSig() === undefined;
    else loggedIn
  "
>
</ng-container>

<ng-template #loggedIn>
  <app-navbar></app-navbar>
</ng-template>
<router-outlet></router-outlet>
